import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross & Blue Shield of Rhode Island",
  shortName: "BCBS Rhode Island",
  slug: "bcbsri-insurance",
  seoTitle:
    "Blue Cross & Blue Shield of Rhode Island TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross & Blue Shield of Rhode Island policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Rhode Island TMS coverage, Blue Cross Blue Shield RI SPRAVATO authorization, BCBSRI mental health benefits Coral Springs FL, BCBS Rhode Island depression treatment Florida",
};

export const BcbsriInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsriInsurance;
